import { Button } from '@/components/ui/button'
import * as Slider from '@/components/ui/slider'
import { DialogContainer } from '@components'
import { For, type Setter, Show, createSignal } from 'solid-js'
import { Grid } from 'styled-system/jsx'

type ScoreDialogProps = {
  title: string
  isOpen: boolean
  setIsOpen: Setter<boolean>
  initialScore?: number | null
  loading?: boolean
  onConfirm: (score: number) => void
}

const ScoreForm = (props: ScoreDialogProps) => {
  const [score, setScore] = createSignal<number>()

  const handleConfirm = () => {
    const s = score() ?? props.initialScore
    if (s) {
      props.onConfirm(s)
    }
  }

  return (
    <Grid
      gap={3}
    >

      <Slider.Root
        step={1}
        max={10}
        defaultValue={[props.initialScore || 0]}
        onValueChange={({ value }) => setScore(value[0])}>
        <Slider.Control>
          <Slider.Track>
            <Slider.Range />
          </Slider.Track>
          <Slider.Thumb index={0}>
            <Slider.HiddenInput />
          </Slider.Thumb>
        </Slider.Control>
        <Slider.MarkerGroup mt={6}>
          <For each={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}>
            {(value) => (
              <Slider.Marker value={value}>
                {value}
              </Slider.Marker>
            )}
          </For>
        </Slider.MarkerGroup>
      </Slider.Root>

      <Grid
        gridTemplateColumns="1fr 1fr"
        gap={3}
        mt={12}
      >
        <Button
          onClick={() => props.setIsOpen(false)}
          variant="outline"
        >
          Cancel
        </Button>
        <Button
          loading={props.loading}
          colorPalette="jade"
          variant="solid"
          onClick={handleConfirm}
        >
          Confirm
        </Button>
      </Grid>
    </Grid>
  )
}

export const ScoreDialog = (props: ScoreDialogProps) => (
  <Show when={props.isOpen}>
    <DialogContainer
      title={props.title}
      isOpen={props.isOpen}
      setIsOpen={props.setIsOpen}
    >
      <ScoreForm {...props} />
    </DialogContainer>
  </Show>
)
